import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { IHandlers, IProps } from './types';
import { Avatar, IconButton, makeStyles, Typography } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import ErrorIcon from '@material-ui/icons/Error';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import CloudOffIcon from '@material-ui/icons/CloudOff';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import LocationService from 'external-services/location-service';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import style from './style.module.scss';
import { APP_COLORS, Colors } from 'design-v2/globals/colors/colors';
import { useSelector } from 'react-redux';
import { DiaryRootState } from 'appRoot/rootReducer';
import BlockOutsService from 'external-services/blockouts-service/blockouts.service';
import { IServiceListView } from 'shared-types/SharedTypes';
import ViewActionsService from 'app/actions/view.actions';
import DateUtilsService from 'external-services/date-utils-service';
import { scheduleActions } from 'app/reducers/schedule/slice';
import { useAppDispatch } from 'appRoot/Store';
import RouteChangeService from "app/services/routeChange/routeChange.service";
import {RouteGCManagement} from "app/services/routeChange/types";
const OFFLINE = 'offline';
const UP_TO_DATE = 'uptodate';

const HELP_URL = 'https://www.nowbookit.com/support';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    borderRadius: '8px',
    maxWidth: '280px'
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    borderBottom: '1px solid rgba(248, 248, 248)',
    '&:hover': {
      backgroundColor: Colors.get(APP_COLORS.clrGreyLight),
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export default function HeaderMenuRight({
                                          isManager, reloadRequired, offlineStatus, handleLockClick,
                                          isOnlineCustomersEnabled, isGiftCardActive, giftUrl, isOfflineDisabled,
                                          handleStatusInfoContainer, promptReloadContainer,
                                        }: IProps & IHandlers) {

  const useStyles = makeStyles({
    onlineStatus: {
      color: offlineStatus === OFFLINE ? Colors.get(APP_COLORS.clrBad) : Colors.get(APP_COLORS.clrGood),
    }
  });

  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [hidingServiceNames, setHidingServiceNames] = useState([]);
  const selectedDate = useSelector((state: DiaryRootState) => state.scheduleReducer.selectedDate);
  const refreshHiddenService = useSelector((state: DiaryRootState) => state.rootDisplayReducer.refreshHiddenService);

  const currentServiceViews = useSelector(
    (state: DiaryRootState) => state.serviceReducer.currentServiceViews
  );
  // this feature no need for now. hidden it. the reason did not remove it is it might need in future.
  // useEffect(() => {
  //   if (selectedDate && currentServiceViews) {
  //     const dateStr = DateUtilsService.dateToDateStr(selectedDate);
  //     BlockOutsService.getHiddenServiceByDate(dateStr).then((dto) => {
  //       dispatch(scheduleActions.setHiddenServices(dto.serviceIds));
  //       const _hidingServiceNames: string[] = [];
  //       currentServiceViews.forEach((serviceView: IServiceListView) => {
  //         if (serviceView.service && serviceView.service._id
  //           && dto.serviceIds.includes(serviceView.service._id)) {
  //           _hidingServiceNames.push(`'${serviceView.service.name}'`);
  //         }
  //       })
  //       setHidingServiceNames(_hidingServiceNames);
  //     })
  //   }
  // }, [selectedDate, currentServiceViews, refreshHiddenService])

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLock = useCallback((event) => {
    handleClose();
    handleLockClick(event);
  }, [handleLockClick]);

  const handleOnlineStatusChange = useCallback((event) => {
    handleClose();
    handleStatusInfoContainer();
  }, [handleStatusInfoContainer]);

  const isOffline = useMemo(() => {
    return offlineStatus === OFFLINE;
  }, [offlineStatus]);
  const showEditHiddenService = () => {
    ViewActionsService.onEditBlockout();
  }

  return (
    <div>

      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        style={{ color: '#fff', padding: '5px' }}
        onClick={handleClick}
      >
        <MoreVertIcon />
        {hidingServiceNames.length > 0 &&
          <div className={style.redPoint}>
          </div>
        }
        {isOffline && <div className={style.offlineIcon}>
          <Avatar className={style.avatar}>
            <CloudOffIcon fontSize="small" style={{fontSize: '10px'}} />
          </Avatar>
        </div> }
      </IconButton>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {/*Hidden service*/}
        {hidingServiceNames.length > 0 &&
        <StyledMenuItem onClick={showEditHiddenService}>
          <ListItemIcon className={style.menuIcon}>
            <ErrorIcon fontSize="small" style={{ color: '#d9398a' }} />
          </ListItemIcon>

          <ListItemText className={style.menuText} disableTypography primary={
            <div>
              <span>Service Hidden</span>
              <br />
              <span className={style.diaryOnlineSubText}>{`${hidingServiceNames.length > 1? hidingServiceNames.length + " services" : hidingServiceNames[0] + ' service'} hidden from the booking widget`}</span>
            </div>
          } />
        </StyledMenuItem>}
        {/*Diary online*/}
        <StyledMenuItem onClick={handleOnlineStatusChange}>
          <ListItemIcon className={style.menuIcon}>
            {isOffline ? <CloudOffIcon fontSize="small" style={{ color: Colors.get(APP_COLORS.clrBad) }} /> :
              <CloudQueueIcon fontSize="small" style={{ color: Colors.get(APP_COLORS.clrGood) }} />}
          </ListItemIcon>

          <ListItemText className={style.menuText} disableTypography primary={
            <div>
              <span>{`${isOffline ? 'Diary offline' : 'Diary online'} ${isOfflineDisabled ? '(offline disabled)' : ''}`}</span>
                <br />
                <span className={style.diaryOnlineSubText}>{isOffline ? `Changes won't be synced until you're back online.` : `All changes will be synced.`}</span>
            </div>
          } />
        </StyledMenuItem>

        {/*Gift card*/}
        {isGiftCardActive &&
          <StyledMenuItem onClick={() => {
            handleClose();
            // LocationService.openInNewTab(giftUrl);
            RouteChangeService.changeRoute(RouteGCManagement.name);
          }}>
            <ListItemIcon className={style.menuIcon}>
              <CardGiftcardIcon  fontSize="small"
                                style={{ color: `${isOffline ? Colors.get(APP_COLORS.clrBad) : Colors.get(APP_COLORS.clrGreyHeavy)}` }} />
            </ListItemIcon>
            <ListItemText className={style.menuText} primary={'Gift cards'} />
          </StyledMenuItem>}

        {/*Reload Required*/}
        {reloadRequired && <StyledMenuItem onClick={() => {
          handleClose();
          promptReloadContainer();
        }}>
          <ListItemIcon className={style.menuIcon}>
            <ErrorIcon fontSize="small" style={{ color: Colors.get(APP_COLORS.clrBad) }} />
          </ListItemIcon>
          <ListItemText className={style.menuText} primary={'Reload required'} />
        </StyledMenuItem>}
        {/*{isOnlineCustomersEnabled && <StyledMenuItem>*/}
        {/*  <ListItemIcon className={style.menuIcon}>*/}
        {/*    <CloudIcon fontSize="small" style={{ color: `${isOffline ? 'red' : 'green'}` }} />*/}
        {/*  </ListItemIcon>*/}
        {/*  <ListItemText className={style.menuText} primary={'Online customers'} />*/}
        {/*</StyledMenuItem>}*/}
        <StyledMenuItem onClick={handleLock}>
          <ListItemIcon className={style.menuIcon}>
            {isManager ? <LockOpenIcon fontSize="small" /> : <LockIcon fontSize="small" />}
          </ListItemIcon>
          <ListItemText className={style.menuText} primary={isManager ? 'Lock Diary' : 'Unlock Diary'} />
        </StyledMenuItem>
        <StyledMenuItem onClick={() => {
          handleClose();
          LocationService.openInNewTab(HELP_URL);
        }}>
          <ListItemIcon className={style.menuIcon}>
            <ContactSupportIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText className={style.menuText} primary={'Help'} />
        </StyledMenuItem>
      </StyledMenu>
    </div>
  );
}
